import { fetchWithAuth } from '../lib/fetchWithAuth';

const API_BASE_URL = import.meta.env.VITE_API_URL?.replace(/\/$/, '');

export type AuditRecord = {
  id: string;
  entity: 'candidate' | 'employer' | 'job' | 'lead';
  entityId: string;
  action: string;
  actor: string;
  createdAt: string;
  summary: string;
  note?: string;
  before?: Record<string, unknown>;
  after?: Record<string, unknown>;
};

export async function fetchAuditLog(entity: AuditRecord['entity'], id: string): Promise<AuditRecord[]> {
  if (!API_BASE_URL) {
    throw new Error('VITE_API_URL is required to load admin audit logs.');
  }
  const params = new URLSearchParams({ entity, id });
  const response = await fetchWithAuth(`${API_BASE_URL}/v1/admin/audit?${params.toString()}`);
  if (!response.ok) {
    const text = await response.text().catch(() => 'request failed');
    throw new Error(`Audit log fetch failed (${response.status}): ${text}`);
  }
  const payload = await response.json();
  return (payload?.records as AuditRecord[]) ?? [];
}
